import React from 'react';
import {AutomatedPaymentsUIProvider} from '../components/AutomatedPaymentsUIContext';
import {AutomatedPaymentsLoadingDialog} from '../components/payments-loading-dialog/AutomatedPaymentsLoadingDialog';
import {AutomatedPaymentsCard} from './AutomatedPaymentsCard';

export function AutomatedPaymentsPage() {
  return (
    <AutomatedPaymentsUIProvider>
      <AutomatedPaymentsLoadingDialog />
      <AutomatedPaymentsCard/>
    </AutomatedPaymentsUIProvider>
  );
}
